import React from "react";
import { Navigate } from "react-router-dom";
import { auth } from "../lib/api";

export default function RequireAuth({ role, loginPath, children }) {
  const u = auth.user;
  if (!auth.token || !u || (role && u.role !== role)) {
    return <Navigate to={loginPath} replace />;
  }
  return children;
}
